<template>
  <div class="d-flex flex-column" :class="{ premium: highlighted, basic: !highlighted }">
    <div class="bg-white pricing-table">
      <h5>{{ title }}</h5>
      <p>{{ subtitle }}</p>

      <div class="mt-5 icon" :class="{ iconPremium: highlighted }">
        <i :class="iconClass"></i>
      </div>

      <div class="price mt-5">
        <p v-if="isFree" class="font-weight-light text-capitalize-first">
          {{ translate('for free') }}
        </p>
        <p v-else :class="{ 'mb-0 pb-0': priceExtra }">
          <span>{{ toCurrency('NOK', price) }}</span>
          <span> / {{ translate('mth') }}</span>
        </p>
      </div>

      <span v-if="priceExtra" class="priceExtra mt-0">{{ priceExtra }}</span>

      <RenderHTML v-if="benefits" class="benefits__list" :value="benefits" />
      <div v-else class="features mt-4">
        <ul class="list-unstyled">
          <li v-for="(feature, j) in features" :key="j">
            <span class="text-dark" :class="itemsNotIncludedClass(feature)">{{ feature.name }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="mt-auto button bg-white">
      <button
        class="btn w-100 text-capitalize-first"
        :class="{ 'btn-outline-primary': !highlighted, 'btn-primary': highlighted }"
        @click="setPlan"
      >
        {{ selectButtonCTA }}
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.pricing-table {
  padding: 30px;

  .text-linethrough {
    text-decoration: line-through;
  }

  .icon {
    i {
      font-size: 3em;
      color: $dark;
    }
  }

  .iconPremium {
    i {
      color: $primary;
    }
  }

  .price {
    span {
      font-weight: bolder;
      font-size: 1.6em;
    }
  }

  .priceExtra {
    font-size: 0.8rem;
  }

  .features {
    ul li:last-child {
      border-bottom: none;
    }

    ul li span {
      display: inline-block;
      margin-right: 1rem;
      font-size: 0.8em;
      padding: 0.4rem 0;
    }
  }
}

.button {
  padding: 0px 30px 30px 30px;
}

.basic {
  border: 1px solid $gray-200;
}

.premium {
  border: 1px solid $gray-200;
}

.benefits__list {
  :deep(ul > li:before) {
    display: none;
  }
  :deep(ul li input[type='checkbox']) {
    display: none;
  }
}
</style>

<script>
import i18nCommon from '@modules/i18n/mixins/Common';
import RenderHTML from '@modules/design-system/components/atoms/RenderHTML.vue';

export default {
  mixins: [i18nCommon],
  components: {
    RenderHTML,
  },
  props: {
    subscription: Object,
    title: String,
    subtitle: String,
    highlighted: {
      type: Boolean,
      dafault: false,
    },
    showFeatureNotIncluded: {
      type: Boolean,
      default: true,
    },
    iconClass: String,
    isFree: {
      type: Boolean,
      default: false,
    },
    price: [Number, String],
    priceExtra: String,
    features: Array,
    benefits: String,
    index: Number,
    selectButtonText: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    selectButtonCTA() {
      return this.selectButtonText ? this.selectButtonText : this.translate('select');
    },
  },
  methods: {
    setPlan() {
      this.$emit('planSet');
    },
    itemsNotIncludedClass(feature) {
      if (!feature.included[this.index] && this.showFeatureNotIncluded) {
        return 'text-linethrough';
      } else if (!feature.included[this.index] && !this.showFeatureNotIncluded) {
        return 'd-none';
      } else {
        return '';
      }
    },
  },
};
</script>
